import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigation } from "react-router";

// Slim top progress bar during navigation. It waits 150ms so fast transitions never flash it,
// creeps toward 90% while loading, then fills and fades out. scaleX/opacity only.
function GlobalLoading() {
  const { t } = useTranslation();
  const navigation = useNavigation();
  const active = navigation.state !== "idle";
  const reduce = useReducedMotion();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!active) return setVisible(false);
    const timer = setTimeout(() => setVisible(true), 150);
    return () => clearTimeout(timer);
  }, [active]);

  return (
    <div
      role="progressbar"
      aria-label={t("ui.checkout.loading")}
      aria-valuetext={visible ? t("ui.checkout.loading") : undefined}
      aria-hidden={!visible}
      className="pointer-events-none fixed inset-x-0 top-[env(safe-area-inset-top)] z-overlay h-[3px] overflow-hidden"
    >
      <AnimatePresence>
        {visible && (
          <motion.div
            key="bar"
            className="h-full bg-accent-text ltr:origin-left rtl:origin-right"
            initial={reduce ? { scaleX: 1, opacity: 0 } : { scaleX: 0, opacity: 1 }}
            animate={reduce ? { scaleX: 1, opacity: 1 } : { scaleX: 0.9, opacity: 1, transition: { duration: 8, ease: [0.08, 0.7, 0.2, 1] } }}
            exit={{ scaleX: 1, opacity: 0, transition: { scaleX: { duration: 0.2 }, opacity: { duration: 0.3, delay: 0.15 } } }}
          />
        )}
      </AnimatePresence>
    </div>
  );
}

export { GlobalLoading };
